var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-uppercase text-white"},[_c('i',{directives:[{name:"tippy",rawName:"v-tippy",value:({ arrow: true }),expression:"{ arrow: true }"}],staticClass:"fa fa-question-circle",attrs:{"content":_vm.$t('settings.help')},on:{"click":_vm.openPage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }